import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import fantasyReducer from "./slices/fantasySlice";

export const store = configureStore({
	reducer: {
		user: userReducer,
		fantasy: fantasyReducer,
	},
});

// Types for hooks
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
